// extracted by mini-css-extract-plugin
export default {"root":"mH5FT","large":"IMfyo","desktop":"Om1P3","diamond":"MR70b","coin":"URuWx","priceValue":"FJnYG","big":"e0tGk","medium":"dkdgX","small":"Bm7kF"};